import { flyInOut, staggeredCards, fadeIn, fade, zFade, customPosition, Cart, ShareMenu, ProductInfo, Stock, CartStep, CartOverlay, CartBackdrop, steppedFly, storeFilters, storetitle,viewInfo,viewDesc,winkey, productAnim, listAnimation, animateOpen, rotateOpen, rotateDown } from '../animations';
import { Component, OnInit, ViewChild, ElementRef, HostListener, Input, Output } from '@angular/core';
import { DomSanitizer, SafeResourceUrl, SafeUrl} from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { SelectComponent } from 'ng-select';
import { Observable } from 'rxjs/Rx';

import { StoreService } from '../../services/store.service';
import { UserService } from '../../services/user.service';

import { Product } from '../../models/product';
import { Account } from '../../models/account';
import { Item } from '../../models/item';
import { Currency } from '../../models/currency';

declare var $: any
declare var MasterSlider: any

@Component({
  selector: 'popular',
  templateUrl: './popular.component.html',
  inputs: [ 'productsPerPage', 'hideHeader', 'showFilters', 'staggerAnimate' ],
  providers: [ StoreService, UserService ],
  animations: [ flyInOut, staggeredCards, fadeIn, fade, zFade, customPosition, ShareMenu, Cart, ProductInfo, Stock, CartStep, CartOverlay, CartBackdrop, steppedFly, storeFilters, storetitle, viewInfo, viewDesc, winkey, productAnim, listAnimation,  animateOpen, rotateOpen, rotateDown ]
})

export class PopularComponent implements OnInit {

	@Input() productsPerPage:any = 12;
	@Input() hideHeader:any = false;
	@Input() showFilters:any = false;
	@Input() staggerAnimate:boolean = true;
	
	

	accounts: Account;
	allproducts: Product;
	cartItems: Product;
	currency: Currency;
	currencies: Currency;
	selection: Array<any> = [];
	purchased: Product;

	popularItems: Item;
	popularProducts: Product;

	title: string;
	header: any;
	headerHeight: any;
	headerAlign: any;
	subtitle: string;
	flips: boolean;

	productPage = 0;
	currencyOpen = -1;
	selectedProduct: number;
	selectedImage: number;
	numberofproducts: number;
	selected: number;
	showDetails: boolean;
	loadingCart: boolean;
	flashCart = false;
	total: any;
	cart: any[];
	sidebar: any;
	searchitems = null;
	storeAdvert = 'false';
	showCards = -1;
	staggeredFlow: any;
	enableCurrencySelector = false;

	constructor(private storeService: StoreService,
				private userService: UserService,
				private route: ActivatedRoute,
				private sanitizer: DomSanitizer,
				private router: Router) {}


	openCurrency(y) {
		this.currencyOpen = (this.currencyOpen >= 0) ? -1 : y;
	}

	changeCurrency(currency) {
		this.currency = currency;
		this.storeService.changeCurrency(currency);
	}


	addToCart(product, i) {
		if ( this.inCart(product.id) ) {

			this.router.navigate(['/checkout']);
			
		} else if (product.instock && !this.inCart(product.id) ) {

			this.storeService.addToCart(product.id);
			this.updateCartButton();
			this.selectedProduct = i;
			this.loadingCart = true;
			this.showDetails = true;
			this.getCart();

		}
	}

	
	updateCartButton() {
	 	this.flashCart = true;
	 	setTimeout( () => { this.flashCart = false; }, 5000);
	}

	removeFromCart(productIndex) {
		this.storeService.removeFromCart(productIndex);
		this.getCart();
	}

	getCart() {
		this.cart = this.storeService.getCartContents();
		Promise.resolve( this.storeService.getProducts(this.cart) ).then((cartdata) => {
			this.cartItems = cartdata;
			this.loadingCart = false;
		});

		this.getTotal();
	}

	getTotal() {
		Promise.resolve(this.storeService.getCartTotal()).then(cartTotal => 
			this.total = cartTotal
		);
	}

	inCart( id ) {
		return ( this.cart.indexOf( id ) > -1 ) ? true : false;
	}



	/**
	* Currencies
	**/
	getCurrencies() {
		Promise.resolve( this.storeService.getCurrencies() ).then((c) => {
			this.currencies = c;
		});

		Promise.resolve( this.storeService.getCurrency() ).then((c) => {
			this.currency = c[0];
		});

		Promise.resolve(this.storeService.enableCurrencySelector()).then((bool) => {
			this.enableCurrencySelector = bool;
		});
	}




	/**
	* Animations
	**/

	stagger(t = 90) {
		if (this.showCards < this.numberofproducts) {
			this.showCards++;
			setTimeout( () => { this.stagger(t); }, t);
		} else { 
			this.showCards = this.numberofproducts;
		}
	}


    /* On with the show */
	ngOnInit() {

		this.title = 'Popular Items';
		this.headerHeight = 700;
		this.header = this.sanitizer.bypassSecurityTrustStyle( 'url( "/assets/img/video/video.jpg") 10%' );
		this.subtitle = 'The most sought after Identity game items.';
		

		/* 
		* Cart System
		*/

		this.getCart();

		Promise.resolve(this.storeService.popularItems()).then((items) => {
			this.popularItems = items;
			setTimeout( () => { this.stagger(90); }, 100);
		});

		Promise.resolve(this.storeService.popularProducts()).then((product) => {
			this.popularProducts = product;
			setTimeout( () => { this.stagger(90); }, 100);
		});

		this.getCurrencies();
		
		$('html, body').animate({scrollTop: 0 }, 210);
  	}

  	ngAfterViewInit() {
  		
  		/**
		 * Product Sliders 
		**/
		if ( !this.hideHeader ) {
			
			var slider = new MasterSlider();

			slider.setup('masterslider' , {
				width:1170,
				view:"flow",
				fullwidth:true,
				height: this.headerHeight,
				autoheight: true,
				loop: true,
				autoplay: false, // debugg = false
				keyboard: true,
				speed: 10,
				instantStartLayers: true,
				filters: {
					opacity: 0.7,
					brightness: 2
				}
			});

			// adds Arrows navigation control to the slider.
			slider.control('arrows');
		}
  	}
}


// WEBPACK FOOTER //
// C:/Users/Asylum/identity-vagrant/src/asylum-idenetity/src/app/store/popular/popular.component.ts